import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions'

const prodConfig = {
    apiKey: "AIzaSyBVaU-JmxaRpKiOCD8KvblwfuixCVzdyOA",
    authDomain: "valdneta-9a87d.firebaseapp.com",
    databaseURL: "https://valdneta-9a87d.firebaseio.com",
    projectId: "valdneta-9a87d",
    storageBucket: "valdneta-9a87d.appspot.com",
    messagingSenderId: "439553045240"
};

const devConfig = {
    apiKey: "AIzaSyBVaU-JmxaRpKiOCD8KvblwfuixCVzdyOA",
    authDomain: "valdneta-9a87d.firebaseapp.com",
    databaseURL: "https://valdneta-9a87d.firebaseio.com",
    projectId: "valdneta-9a87d",
    storageBucket: "valdneta-9a87d.appspot.com",
    messagingSenderId: "439553045240"
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();
const functions = firebase.functions();

export {
  db,
  auth,
  functions,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js